<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $t('manualShipments') }}
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 md4>
                <v-text-field v-model="shipmentId"
                  append-icon="search"
                  label="#"
                  @click:append="fetch({shipmentId: shipmentId}, true)"
                  clearable
                  @keyup.enter.native="fetch({shipmentId: shipmentId}, true)"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-data-table class="elevation-1"
          :headers="headers"
          hide-headers
          :items="items"
          :loading="loading"
          :total-items="totalItems"
          :pagination.sync="pagination"
          item-key="id"
          :no-data-text="$t('noDataAvailable')">
          <template v-slot:items="props">
            <tr>
              <td width="5%" @click="props.expanded = !props.expanded">
                {{ props.item.id }}
              </td>

              <td @click="props.expanded = !props.expanded">
                {{ props.item.destination.name }}
              </td>

              <td @click="props.expanded = !props.expanded">
                {{ props.item.destination.street }}
              </td>

              <td @click="props.expanded = !props.expanded">
                <Status :shipment="props.item"></Status>
              </td>

              <td class="text-xs-right">
                <Pack :shipment="props.item"></Pack>
                <SelectRate :shipment="props.item"></SelectRate>
                <Download :shipment="props.item"></Download>
                <GenerateLabel :shipment="props.item"></GenerateLabel>
              </td>

              <td class="pa-0 pr-2 text-xs-right">
                <v-btn color="primary" flat icon v-if="!props.expanded" @click="props.expanded = !props.expanded">
                  <font-awesome-icon icon="angle-left"></font-awesome-icon>
                </v-btn>

                <v-btn color="primary" flat icon v-if="props.expanded" @click="props.expanded = !props.expanded">
                  <font-awesome-icon icon="angle-down"></font-awesome-icon>
                </v-btn>
              </td>
            </tr>
          </template>

          <template v-slot:expand="props">
            <ShipmentDetails :shipment="props.item" @fetch="fetch"></ShipmentDetails>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Enum from '@/client/enum'
import Store from '@/client/store'
import Shipment from '@/client/shipment'

import Status from '@/components/shipments/btns/status'
import Pack from '@/components/shipments/btns/pack'
import SelectRate from '@/components/shipments/btns/select-rate'
import Download from '@/components/shipments/btns/download'
import ShipmentDetails from '@/components/shipments/details'
import GenerateLabel from '@/components/shipments/btns/add-label'

export default {
  // name: 'ManualShipmentsView',

  props: {},

  data () {
    return {
      headers: [
        { text: '', align: 'left', sortable: false, value: '' },
        { text: '', align: 'left', sortable: false, value: '' },
        { text: '', align: 'left', sortable: false, value: '' },
        { text: '', align: 'left', sortable: false, value: '' },
        { text: '', align: 'left', sortable: false, value: '' },
        { text: '', align: 'left', sortable: false, value: '' }
      ],
      totalItems: 0,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'created_at',
        descending: true
      },
      items: [],
      loading: false,
      syncing: false,
      enums: {},
      stores: [],
      mountedFirst: true,
      params: {},
      shipmentId: ''
    }
  },

  components: {
    Status,
    Pack,
    SelectRate,
    Download,
    ShipmentDetails,
    GenerateLabel
  },

  computed: {
    hasStores () {
      if (!this.stores) { return false }

      return this.stores.length > 0
    }
  },

  methods: {
    async setup () {
      this.enums = await Enum.all()
      this.stores = await Store.all()
    },

    async fetch (params = {}, filter = false) {
      this.loading = true
      if (filter) this.params = params

      const { sortBy, descending, page, rowsPerPage } = this.pagination
      let order = ''
      if (sortBy) {
        order = `shipments.${sortBy} ${descending ? 'desc' : 'asc'}`
      }

      let where = {}
      where.source = 'manual'
      if (this.params.shipmentId) { where.id = this.params.shipmentId }

      this.items = await Shipment.all({
        order,
        page,
        per_page: rowsPerPage,
        where,
        include: [
          'origin',
          'destination',
          { rate: { service: 'carrier' } },
          'generated_label',
          'user',
          'parcel',
          'labels'
        ]
      })

      this.totalItems = this.items.pagination.total_objects
      this.loading = false

    },
  },

  watch: {
    pagination: {
      handler () {
        if (this.mountedFirst && this.$route.query.shipment_id) {
          this.fetch({shipmentId: this.shipmentId}, true)
          this.mountedFirst = false
        }
        else {
          this.fetch()
        }
      },
    }
  },

  async mounted () {
    if (this.$route.query.shipment_id) {
      this.shipmentId = this.$route.query.shipment_id
    }
    this.setup()
  }
}
</script>
